import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router";

import Home from "../Pages/Home";
import Search from "../Pages/Search";
// import SpaceVanueList from "../Pages/SpaceVanueList";
import SpaceVanueDetails from "../Pages/SpaceVanueDetails";
import LoginPage from "../Pages/Auth/Login";
import SignupPage from "../Pages/Auth/SignupPage";

import UserVenuesList from "../Pages/User/VenuesList";
import UserBookingsList from "../Pages/User/BookingsList";
import UserMessagesList from "../Pages/User/MessagesList";
import UserPaymentsList from "../Pages/User/PaymentsPage";
import UserNotificationsList from "../Pages/User/NotificationsList";
import UserSettingsList from "../Pages/User/Settings";

import OnBoarding from "../Pages/OnBoarding/OnBoarding";
import ProfilePage from "../Pages/Admin/ProfilePage";
import VenuesList from "../Pages/Admin/VenuesList";
import AdminBookingsList from "../Pages/Admin/BookingsList";
import DashboardPage from "../Pages/Admin/DashboardPage";
import PaymentsPage from "../Pages/Admin/PaymentsPage";

import useLoginCheck from "../Hooks/useLoginCheck";
import LoaderScreen from "../Pages/LoaderScreen";
import GoogleLogin from "../Pages/demo/GoogleLogin";

import GuestRouter from "./GuestRoute";
import AuthRoute from "./AuthRoute";
import AdminRoute from "./AdminRoute";
import UsersList from "../Pages/Admin/AdminUsersList";
import { useDispatch } from "react-redux";
import { getLocalData } from "../utils/LocalStorage";
import { THEME_STATE_TEXT } from "../Constants";
import { toogleThemeMode } from "../Services/Store/Reducers/ThemeReducers";
import UsersFavoritesList from "../Pages/User/UsersFavoritesList";
import StripePayouts from "../Pages/User/StripePayouts";

const AppRoutes = () => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useLoginCheck();
  const [loading, setLoading] = useState(true);

  const router = createBrowserRouter([
    // { path: "/", element: <DemoOne /> },
    // { path: "/voice-demo", element: <VoiceFormDemo /> },
    // { path: "/dropdown-demo", element: <DropdownDemo /> },
    { path: "/", element: <Home /> },
    { path: "/search", element: <Search /> },
    // { path: "/vanue/:id", element: <SpaceVanueDetails /> },
    { path: "/space/:id", element: <SpaceVanueDetails /> },

    { path: "/login", element: <GuestRouter component={LoginPage} /> },
    { path: "/signup", element: <GuestRouter component={SignupPage} /> },

    {
      path: "/get-started",
      element: <AuthRoute component={OnBoarding} />,
      // element: <OnBoarding />,
    },

    { path: "/user", element: <AuthRoute component={UserVenuesList} /> },
    {
      path: "/user/dashboard",
      element: <AuthRoute component={UserVenuesList} />,
    },
    { path: "/user/venues", element: <AuthRoute component={UserVenuesList} /> },
    { path: "/user/profile", element: <AuthRoute component={ProfilePage} /> },
    {
      path: "/user/payments",
      element: <AuthRoute component={UserPaymentsList} />,
    },
    {
      path: "/user/bookings",
      element: <AuthRoute component={UserBookingsList} />,
    },
    {
      path: "/user/favorites",
      element: <AuthRoute component={UsersFavoritesList} />,
    },
    {
      path: "/user/payouts",
      element: <AuthRoute component={StripePayouts} />,
    },
    {
      path: "/user/messages",
      element: <AuthRoute component={UserMessagesList} />,
    },
    {
      path: "/user/conversation/:id",
      element: <AuthRoute component={UserMessagesList} />,
    },
    { path: "/user/settings", element: <UserSettingsList /> },
    {
      path: "/user/notifications",
      element: <AuthRoute component={UserNotificationsList} />,
    },

    { path: "/admin", element: <AdminRoute component={VenuesList} /> },
    {
      path: "/admin/dashboard",
      element: <AdminRoute component={DashboardPage} />,
    },
    { path: "/admin/profile", element: <AdminRoute component={ProfilePage} /> },
    { path: "/admin/venues", element: <AdminRoute component={VenuesList} /> },
    {
      path: "/admin/bookings",
      element: <AdminRoute component={AdminBookingsList} />,
    },
    {
      path: "/admin/payments",
      element: <AdminRoute component={PaymentsPage} />,
    },
    {
      path: "/admin/users",
      element: <AdminRoute component={UsersList} />,
    },
    {
      path: "/admin/messages",
      element: <AdminRoute component={UserMessagesList} />,
    },
    {
      path: "/admin/notifications",
      element: <AdminRoute component={UserNotificationsList} />,
    },
  ]);

  useEffect(() => {
    const currentMode = getLocalData(THEME_STATE_TEXT);

    dispatch(
      toogleThemeMode({ mode: currentMode ? currentMode : "light-mode" })
    );

    const loginCheck = async () => {
      try {
        await isLoggedIn();
      } catch (err) {
        console.log("Login Check ERR :", err);

        if (err.status === 401) {
        }
      }

      setLoading(false);
    };

    loginCheck();
  }, []);

  if (loading) {
    return <LoaderScreen />;
  }

  return <RouterProvider router={router} />;
};

export default AppRoutes;
